module.exports = __webpack_public_path__ + "static/case3.png";